import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { Link, Link2, BtnLink } from "./link";
import { useLocation, useNavigate } from "react-router";
import { useGoogleLogin } from "@react-oauth/google";
import AuthService from "../api/auth";
import { useAuth } from "../contexts/AuthCtx";

const NavigationBar = () => {
  const [showHero, setShowHero] = useState(false);
  const [status, setStatus] = useState("idle");

  const authCtx = useAuth();

  const navigateTo = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      setShowHero(true);
    } else {
      setShowHero(false);
    }
  }, [location.pathname]);

  const onSuccess = async (tokenResponse) => {
    setStatus("loading");
    console.log("T :: ", tokenResponse)
    AuthService.loginGoogle(tokenResponse).then((response) => {
      if (
        response.status &&
        (response.status === 200 || response.status === 201)
      ) {
        let accessTk = response.data.token;
        authCtx.saveAccessToken(accessTk, true);
      } else {
        setStatus("failed");
      }
    });
  };

  const onFailed = (err) => {
    setStatus("failed");
  };

  const handleLogin = useGoogleLogin({
    onSuccess: onSuccess,
    onError: onFailed,
  });

  useEffect(() => {
    if (status === "failed") {
      setTimeout(() => {
        setStatus("idle");
      }, 3000);
    }
  }, [status]);

  const handleConsoleClick = (e) => {
    navigateTo("/app");
  }

  const handleConditionApp = (e) => {
    if(authCtx.authenciated) {
      navigateTo("/app");
    }
    else
    {
      handleLogin(e);
    }
  }

  return (
    <nav className="navigation-bar">
      <div className="inner-navbar">
        <div onClick={(e) => (window.location.href = "/")} className="logo">
          helpx.io
        </div>
        <div className="links">
          <Link text={"Services & APIs"} />
          <Link text={"Contact us"} />
          <Link text={"Request feature"} />
          {authCtx.authenciated ? <Button style={{ borderRadius: 16 }} onClick={handleConsoleClick} type={"primary"}>Console</Button> : <Button
            onClick={handleLogin}
            type={"primary"}
            style={{ borderRadius: 16 }}
            loading={status === "loading"}
            disabled={status !== "idle" && status !== "loading"}
          >
            {status === "failed" ? "Failed to login" : "Login"}
          </Button>}
        </div>
      </div>
      {showHero && (
        <div className="nav-hero">
          <div className="card-holder">
            <div className="card">
              <div className="inner">
                <div className="hdr">
                  <div className="title">
                    <span>guruji</span>
                  </div>
                  <div className="desc">
                    <p>
                      Build your apps, websites and services on helpx guruji,
                      which can help your users with every step.
                    </p>
                  </div>
                </div>
                <div className="footer">
                  <BtnLink onClick={handleConditionApp} text={"test it out"} type={"secondary"} />
                  <BtnLink onClick={handleConditionApp} text={"view docs"} type={"secondary"} />
                  <BtnLink onClick={handleConditionApp} text={"get started"} type={"primary"} />
                </div>
              </div>
            </div>
          </div>
          <div className="info">
            <div className="info-inner">
              <h1>We’re working on more great things...</h1>
              <h1>Thanks for understanding.</h1>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavigationBar;
